import { render, staticRenderFns } from "./law-title.vue?vue&type=template&id=b103a288&scoped=true&"
import script from "./law-title.vue?vue&type=script&lang=js&"
export * from "./law-title.vue?vue&type=script&lang=js&"
import style0 from "./law-title.vue?vue&type=style&index=0&id=b103a288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b103a288",
  null
  
)

export default component.exports